import React from 'react'
import CV from '../../assets/Trevor_Moir-Resume.pdf'
//import CV from `${window.ENV.cvURLBack}`

export default function CTA() {

  //const CV = import(window.ENV.cvURL);
  const CVName = window.ENV.cvName;

  return (
    <div className='cta'>
        <a href={CV} download={CVName} className="btn" target="_blank" rel="noreferrer">Download CV</a>
        <a href="#contact" className="btn btn-primary">Let's Talk</a>
    </div>
  )
}
